interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "default" | "onDark";
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "default",
  className = "",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  const isOnDark = tone === "onDark";

  return (
    <div
      className={`${isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}
    >
      {eyebrow && (
        <span
          className={`mb-3 inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-label font-semibold uppercase tracking-[0.18em] ${
            isOnDark
              ? "bg-primary-50/10 text-accent-300"
              : "bg-accent-100 text-accent-900"
          }`}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2
        className={`text-2xl font-heading font-bold text-balance md:text-4xl ${
          isOnDark ? "text-primary-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            isOnDark ? "text-primary-100" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}